import { Module } from 'vuex';

import { ITimeOffCalendarData } from '@/models';
import { IRootState } from '@/store';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import {
  ICalendarTimeOffHolidaysData,
  ITimeOffCalendarState
} from './timeoff-calendar.types';

export const state: ITimeOffCalendarState = {
  version: 1,
  calendars: [] as ITimeOffCalendarData[],
  calendarHolidays: [] as ICalendarTimeOffHolidaysData[]
};

const namespaced = true;

export const timeOffCalendar: Module<ITimeOffCalendarState, IRootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
